import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { MDVIP_INVOICE_SLOGAN, UTMData } from '../Constants'
import { useBreakpoint } from '../hooks/useBreakpoint'
import { push_pageview } from '../service/analytics'
import { invoice, reset } from '../store'
import IDForm from './Forms/IDForm'
import InvoiceForm from './Forms/InvoiceForm'
import OtherForm from './Forms/OtherForm/OtherForm'
import Tabs from './misc/Tabs'

const SloganProvider: React.FC<{ isInvoice: boolean }> = ({ isInvoice }) => {
  const [slogan, setSlogan] = useState('')
  const location = useLocation()

  useEffect(() => {
    if (isInvoice && location.pathname === '/') {
      setSlogan(MDVIP_INVOICE_SLOGAN)
    } else {
      setSlogan('')
    }
  }, [isInvoice, location.pathname])

  if (!slogan) return null
  return <div className="slogan">{slogan}</div>
}
const VerifyAccount: React.FC = () => {
  const breakpoint = useBreakpoint()
  const dispatch = useDispatch()

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [isInvoice, setIsInvoice] = useState(false)

  useEffect(() => {
    push_pageview({ page_id: 'express_pay_verify_account', page_name: 'Verify Account' })
    const params = new URLSearchParams(window.location.search)
    const UTM_Source__c = params.get('utm_source') || params.get('mdvip_source') || 'direct'
    const UTM_Medium__c = params.get('utm_medium') || params.get('mdvip_medium') || 'none'
    const UTM_Campaign__c = params.get('utm_campaign') || params.get('mdvip_campaign') || ''
    const Source_URL__c = location.href || 'https://www.mdvip.com/pay?undefined'

    const UTMValues: UTMData = {
      Source_URL__c: Source_URL__c,
      Web_MD_Domain__c: Source_URL__c,
      UTM_Campaign__c: UTM_Campaign__c,
      UTM_Medium__c: UTM_Medium__c,
      UTM_Source__c: UTM_Source__c,
      UTM_Term__c: params.get('utm_term') || params.get('mdvip_term'),
    }

    // @todo move mdvip_ep_customer_data to redux store.
    window.sessionStorage.removeItem('mdvip_ep_customer_data')
    const mdvip_ep_customer_data = JSON.stringify(UTMValues)
    window.sessionStorage.setItem('mdvip_ep_customer_data', mdvip_ep_customer_data)

    const documentId = params.get('doc_id')
    const clientId = params.get('id')

    // Enable Invoice Flow.
    if (
      documentId &&
      clientId &&
      /^[0-9]+$/.test(documentId) && // Ensure documentId is alphanumeric.
      /^[a-zA-Z0-9]+$/.test(clientId) && // Ensure clientId is alphanumeric.
      clientId.length == 18 // Ensure clientId is alphanumeric.
    ) {
      // It is the invoice Flow
      dispatch(invoice({ documentId: documentId.toString().trim(), clientId: clientId.toString().trim() }))
      setSelectedTabIndex(2)
      setIsInvoice(true)
    } else {
      setIsInvoice(false)
      dispatch(reset())
    }
  }, [])

  return (
    <div className="content-background">
      <h2 className="content-heading">Verify Account</h2>
      <SloganProvider isInvoice={isInvoice} />
      <Tabs
        items={[
          { key: 'id', label: 'MDVIP ID', content: <IDForm />, disabled: isInvoice },
          { key: 'invoice', label: 'Invoice #', content: <InvoiceForm />, disabled: isInvoice },
          { key: 'other', label: breakpoint === 'xs' ? 'Phone/Zip' : 'Phone/Zip Code', content: <OtherForm /> },
        ]}
        defaultIndex={0}
        selectedIndex={selectedTabIndex}
        onChange={setSelectedTabIndex}
      />
    </div>
  )
}

export default VerifyAccount
